import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { debounceTime, map, catchError, switchMap, finalize } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class UniqueDomainValidatorService implements AsyncValidator {

  private readonly _isChecking = new BehaviorSubject<boolean>(false);
  readonly isChecking$ = this._isChecking.asObservable();

  constructor(private readonly http: HttpClient) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    if (!control.value) {
      return of(null);
    }

    this._isChecking.next(true);

    return of(control.value).pipe(
      debounceTime(500),
      switchMap(value =>
        this.http.get(environment.apiUrl + `/public/${value}`)
      ),
      map(response => {
        if (response == true) {
          return { domainTaken: true };
        }

        return null;
      }),
      catchError((err: unknown) => {
        const status = err instanceof HttpErrorResponse ? err.status : 0;
        // 404 from a misconfigured gateway/upstream is not "domain taken"
        if (status === 0) {
          return of({ apiError: true, apiUnavailable: true });
        }
        if (status === 404 || status >= 500) {
          return of({ apiError: true, apiUnavailable: true, status });
        }
        return of({ apiError: true, status });
      }),
      finalize(() => this._isChecking.next(false))
    );
  }
}
